import React from "react";

import { templates } from "@reactivated";

import { MasonryHeroBlock } from "../components/MasonryHeroBlock";

export const Template = (
    props: templates.MasonryHeroBlockTemplate,
): React.JSX.Element => {
    return <MasonryHeroBlock value={props.value} />;
};
